import React from 'react';

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

/**
 * Converts URLs within text to clickable links
 * @param text The text that may contain URLs
 * @returns React JSX with clickable links
 */
export const formatTextWithLinks = (text: string | null | undefined): React.ReactNode => {
  if (!text) return '-';
  
  // Regular expression to match URLs
  // This pattern matches common URL formats including http, https, ftp protocols
  // as well as www. prefixed URLs
  const urlRegex = /(https?:\/\/|www\.)[^\s<>]+\.[^\s<>]+/g;
  
  // If no URLs found, return the original text
  if (!urlRegex.test(text)) {
    return text;
  }
  
  // Reset regex lastIndex
  urlRegex.lastIndex = 0;
  
  // Split the text by URLs and create an array of text and link elements
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;
  
  while ((match = urlRegex.exec(text)) !== null) {
    // Add text before the URL
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    
    // Get the matched URL
    const url = match[0];
    
    // Ensure URL has proper protocol for href
    const href = url.startsWith('www.') ? `https://${url}` : url;
    
    // Add the link element
    parts.push(
      React.createElement('a', {
        key: match.index,
        href: href,
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'text-primary hover:text-primary-dark hover:underline'
      }, url)
    );
    
    lastIndex = match.index + url.length;
  }
  
  // Add any remaining text after the last URL
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  
  return React.createElement(React.Fragment, null, ...parts);
};
